import { InjectionKey, ref } from 'vue';
import { _Program } from '@/modules/Program';
import { ProgramWorkerData } from '@/modules/ProgramWorkerData';

export const useProgramWorkerData = () => {
  const _programWorkerDatum = ref<Map<string, ProgramWorkerData>>(new Map());

  /**
   * 指定された番組IDに対して、programWorkerから受け取ったデータをセットする
   * @param id
   * @param futurePrograms
   */
  const setProgramWorkerDatum = (programWorkerData: ProgramWorkerData) => {
    _programWorkerDatum.value.set(programWorkerData.programId, programWorkerData);
  };

  /**
   * 指定された番組IDのデータを取得する
   * @param id
   * @returns
   */
  const getProgramWorkerDatum = (id: _Program['id']) => {
    return _programWorkerDatum.value.get(id);
  };

  /**
   * 指定された番組IDのデータを削除する
   * @param id
   */
  const deleteProgramDatum = (id: _Program['id']) => {
    _programWorkerDatum.value.delete(id);
  };

  return { setProgramWorkerDatum, getProgramWorkerDatum, deleteProgramDatum };
};

export type UseProgramWorkerDataType = ReturnType<typeof useProgramWorkerData>;
export const programWorkerDataKey: InjectionKey<UseProgramWorkerDataType> = Symbol('useProgramWorkerData');
